import React, { useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import DataTable from "../../../Components/UI/table/DataTable";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { useMutation, useQuery } from "react-query";
import { deleteRatingKeys, getRatingKeys, updateRatingKeys } from "../../../MyApi/ratings";
import RatingModal from "./ratingModal";
import i18next from "i18next";

const Ratings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);

  const { data, isLoading, refetch, error } = useQuery("getRatingKeys", getRatingKeys);

  const ratings = data?.data?.data || [];

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setModalMode("add");
    setModalId(null);
  };

  const handleAddClick = () => {
    setModalMode("add");
    setModalId(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (id) => {
    setModalMode("edit");
    setModalId(id);
    setIsModalOpen(true);
  };

  const handleViewClick = (id) => {
    setModalMode("show");
    setModalId(id);
    setIsModalOpen(true);
  };
  const columnsRating = [
    {
      label: "التقييم",
      render: (row) => (
        <div className="d-flex align-items-center gap-3">
        
          <div>
            <h6 className="font16">{row.label}</h6>
            <p>#{row.id}</p>
          </div>
        </div>
      ),
    },

    { label: "النوع", accessor: "label" },
    {
      label: "الحالة",
      render: (row) => <StatusBadge status={row?.is_active ? "active" : ""} />,
    },

    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleViewClick(row.id)}
          edit={() => handleEditClick(row.id)}
          deleteFn={deleteRatingKeys}
          mutationKey={["deleteRatingKeys"]}
          refetch={refetch}
          isLoading={isLoading}
          id={row.id}
          viewPermission={"view_rating_key"}
          deletePermission={"delete_rating_key"}
          editPermission={"update_rating_key"}
          togglePermission={"update_rating_key"}
          toggleMutationKey={"toggle-update-rating-key"}
          queryKey={"getRatingKeys"}
          toggleFn={(id, status) => updateRatingKeys({is_active: status, "_method": "PUT", lang: i18next.language}, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

  return (
    <div>
      <RatingModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        refetch={refetch}
        modalMode={modalMode}
        modalId={modalId}
      />
      <HeaderBar
        title={"التقييمات"}
        content={"إدارة الأسئلة التي تظهر للعملاء عند تقييم الطلب."}
      />
      <DataTable
        title={"التقييمات"}
        data={ratings}
        columns={columnsRating}
        actionLabel={"إضافة تقييم جديد "}
        onAddClick={handleAddClick}
        isLoading={isLoading}
        createPermission={"create_rating_key"}
        error={error}
        onRetry={() => refetch()}
      />
    </div>
  );
};

export default Ratings;
